import React from "react";

const ROLES = [
  {
    key: "parent",
    title: "Parent / Guardian",
    desc: "For parents and guardians to track their children's growth, nutrition, and development.",
    icon: "👨‍👩‍👧",
  },
  {
    key: "doctor",
    title: "Doctor",
    desc: "For pediatricians and clinicians to assess and review children's health reports.",
    icon: "🩺",
  },
  {
    key: "school",
    title: "School",
    desc: "For school administrators to enable screening programs and branded reports for students.",
    icon: "🏫",
  },
  {
    key: "class_teacher",
    title: "Class Teacher",
    desc: "For teachers invited by a school to view aggregated class-level growth data.",
    icon: "👩‍🏫",
    badge: "Invite code required",
  },
];

export default function RoleSelectionGrid({ value, onChange }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="role-grid">
      {ROLES.map((r) => {
        const selected = value === r.key;
        return (
          <button
            type="button"
            key={r.key}
            onClick={() => onChange(r.key)}
            data-testid={`role-card-${r.key}`}
            className={`text-left p-4 rounded-xl border transition ${
              selected
                ? "border-sky-400 bg-sky-400/10 ring-1 ring-sky-400"
                : "border-slate-700 bg-[#0E1A3A] hover:border-slate-500"
            }`}
          >
            <div className="flex items-start gap-3">
              <span className="text-2xl" aria-hidden>{r.icon}</span>
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="font-medium text-slate-100">{r.title}</h3>
                  {r.badge && (
                    <span className="text-[10px] uppercase tracking-wide bg-amber-400/20 text-amber-300 px-1.5 py-0.5 rounded">
                      {r.badge}
                    </span>
                  )}
                </div>
                <p className="text-xs text-slate-400 mt-1 leading-relaxed">{r.desc}</p>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
